// Web Audio SFX - both horn (green button) and whistle (red challenge button) use uploaded MP3s.
const HORN_URL = "https://customer-assets-jt897jd0.emergentagent.net/job_music-quiz-game-2/artifacts/qg47r1qj_dragon-studio-air-horn-sound-effect-372453%20%281%29.mp3";
const WHISTLE_URL = "https://customer-assets-jt897jd0.emergentagent.net/job_music-quiz-game-2/artifacts/396282n8_universfield-whistle-slide-down-03-352451.mp3";
// Magic click for the player "Ready to Play" gate button.
const MAGIC_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/2glehb5x_humordome-magic-button-click-453255.mp3";
// Cinematic whoosh for the Join / Start button (name entry screen).
const WHOOSH_URL = "https://customer-assets-0z36b82j.emergentagent.net/job_c96f2f85-8950-4220-b05e-751848d0ff3e/artifacts/9ch1ccfh_dragon-studio-whoosh-cinematic-sound-effect-376889.mp3";

// Preload each sound once so playback is instant on tap.
const makeAudio = (url, volume = 0.9) => {
  const el = new Audio(url);
  el.preload = "auto";
  el.crossOrigin = "anonymous";
  el.volume = volume;
  return el;
};

let hornEl = null;
const getHornEl = () => {
  if (!hornEl) hornEl = makeAudio(HORN_URL, 0.9);
  return hornEl;
};

let whistleEl = null;
const getWhistleEl = () => {
  if (!whistleEl) whistleEl = makeAudio(WHISTLE_URL, 0.9);
  return whistleEl;
};

let magicEl = null;
const getMagicEl = () => {
  if (!magicEl) magicEl = makeAudio(MAGIC_URL, 0.9);
  return magicEl;
};

let whooshEl = null;
const getWhooshEl = () => {
  if (!whooshEl) whooshEl = makeAudio(WHOOSH_URL, 0.9);
  return whooshEl;
};

// Warm up preload on module import
try { getHornEl(); getWhistleEl(); getMagicEl(); getWhooshEl(); } catch {}

const playEl = (el) => {
  try {
    el.currentTime = 0;
    const p = el.play();
    if (p && typeof p.catch === "function") p.catch(() => {});
  } catch {}
};

export function playHorn() { playEl(getHornEl()); }
export function playWhistle() { playEl(getWhistleEl()); }
export function playMagic() { playEl(getMagicEl()); }
export function playWhoosh() { playEl(getWhooshEl()); }

// Suspenseful clock tick synthesised on the fly (no asset needed) — used during
// the G1 5s challenge countdown. `urgent` raises pitch/volume for the last seconds.
let _ac = null;
const getAC = () => {
  if (!_ac) {
    try { _ac = new (window.AudioContext || window.webkitAudioContext)(); } catch {}
  }
  return _ac;
};

export function playTick(urgent = false) {
  const ac = getAC();
  if (!ac) return;
  try {
    if (ac.state === "suspended") ac.resume();
    const now = ac.currentTime;
    const osc = ac.createOscillator();
    const gain = ac.createGain();
    osc.type = "square";
    osc.frequency.setValueAtTime(urgent ? 1400 : 900, now);
    osc.frequency.exponentialRampToValueAtTime(urgent ? 900 : 560, now + 0.06);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.exponentialRampToValueAtTime(urgent ? 0.4 : 0.24, now + 0.004);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.1);
    osc.connect(gain).connect(ac.destination);
    osc.start(now);
    osc.stop(now + 0.11);
  } catch {}
}
